// ===============================
// GLOBAL PRODUCT CARD HANDLER
// ===============================

function initProductCards(scope = document) {

  const cards = scope.querySelectorAll(
    '.card-product-action-container, .product-action-container'
  );

  if (!cards.length) return;

  cards.forEach((card) => {

    // Prevent duplicate binding
    if (card.dataset.initDone === 'true') return;
    card.dataset.initDone = 'true';

    const select = card.querySelector('.variant-selector');
    const button = card.querySelector('.add-to-bag-btn');

    if (!button) return;

    // 🔥 Find wrapper safely
    const wrapper =
      card.closest('.grid__item') ||
      card.closest('.product-card-container') ||
      card.closest('li') ||
      card.parentElement;

    if (!wrapper) return;

    const productJsonEl = wrapper.querySelector('.product-json');
    if (!productJsonEl) {
      console.warn('❌ product-json not found');
      return;
    }

    const productData = JSON.parse(productJsonEl.textContent);

    // 🔥 Detect both price structures
    const priceWrapper = wrapper.querySelector('.price-wrapper');
    const customPrice = wrapper.querySelector('.product-price');

    // ===============================
    // UPDATE FUNCTION
    // ===============================
    function updateUI() {

      let variant;

      if (select) {
        const variantId = select.value;
        variant = productData.variants.find(v => v.id == variantId);
      } else {
        variant = productData.variants[0];
      }

      if (!variant) return;

      // ===============================
      // STOCK HANDLING
      // ===============================
      if (!variant.available) {
        button.classList.add('is-out-of-stock');
        button.disabled = true;
        button.innerText = 'Out of Stock';
      } else {
        button.classList.remove('is-out-of-stock');
        button.disabled = false;

        button.innerHTML =
          '<span class="bag-icon">' +
          '<img src="https://cdn.shopify.com/s/files/1/0751/2142/6743/files/Bag_Icon_b843214a-bae6-4165-8d2b-75eda164c81e.svg" class="img_bag_icn">' +
          '</span>' +
          'Add to Bag';
      }

      // ===============================
      // PRICE UPDATE (SAFE)
      // ===============================

      // 🔹 CASE 1: COLLECTION PAGE (Shopify default)
      if (priceWrapper) {

        const dd = priceWrapper.querySelector('dd');
        if (!dd) return;

        const compareEl = dd.querySelector('.price-item--compare bdi');
        const saleEl = dd.querySelector('.price-item--sale bdi');
        const regularEl = dd.querySelector('.price-item--regular bdi');

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {

          if (compareEl) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.closest('.price-item--compare').style.display = 'inline-block';
          }

          if (saleEl) {
            saleEl.textContent = formatMoney(variant.price);
            saleEl.closest('.price-item--sale').style.display = 'inline-block';
          }

          if (regularEl) {
            regularEl.closest('.price-item--regular').style.display = 'none';
          }

        } else {

          if (regularEl) {
            regularEl.textContent = formatMoney(variant.price);
            regularEl.closest('.price-item--regular').style.display = 'inline-block';
          }

          if (compareEl) {
            compareEl.closest('.price-item--compare').style.display = 'none';
          }

          if (saleEl) {
            saleEl.closest('.price-item--sale').style.display = 'none';
          }
        }
      }

      // 🔹 CASE 2: CUSTOM SECTION (your best selling)
      if (customPrice) {

        let html = '';

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html =
            '<span class="original-price">₹' + (variant.compare_at_price / 100).toFixed(2) + '</span>' +
            '<span class="discounted-price">₹' + (variant.price / 100).toFixed(2) + '</span>';
        } else {
          html =
            '<span class="discounted-price">₹' + (variant.price / 100).toFixed(2) + '</span>';
        }

        customPrice.innerHTML = html;
      }

      // ===============================
      // UPDATE BUTTON VARIANT ID
      // ===============================
      if (variant.id) {
        button.setAttribute('data-id', variant.id);
      }

    }

    // INIT
    updateUI();

    // EVENT
    if (select) {
      select.addEventListener('change', updateUI);
    }

  });

}

// ===============================
// MONEY FORMAT
// ===============================
function formatMoney(cents) {
  return '₹' + (cents / 100).toFixed(2);
}

// ===============================
// GLOBAL INIT
// ===============================
document.addEventListener('DOMContentLoaded', () => {
  initProductCards();
});

document.addEventListener('shopify:section:load', (e) => {
  initProductCards(e.target);
});